import { useEffect } from 'react';

/**
 * Custom hook for synchronizing a state value with a form field.
 *
 * @param {any} stateValue - The current/external value of the state to be synchronized with the form field.
 * @param {Function} setValue - A function from `useForm` to set the value of a specific form field.
 * @param {Function} trigger - A function from `useForm` to manually trigger form validation.
 * @param {any} [defaultValue=''] - The default value to set for the form field if the state value is not present or empty.
 * @param {string} field - The name of the form field to be synchronized with the state value.
 * @returns {void} This hook does not return anything.
 */

const useSyncFieldToForm = (stateValue, setValue, trigger, defaultValue = '', field) => {
    useEffect(() => {
        if (typeof setValue !== 'function' && typeof trigger !== 'function') {
            return;
        }
        if (!stateValue || !stateValue.length) {
            setValue(field, defaultValue);
            trigger(field);
        } else {
            setValue(field, stateValue);
            trigger(field);
        }
    }, [stateValue, setValue, trigger]);
};

export default useSyncFieldToForm;
